import React, {
  useState,
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from "react";
import classNames from "classnames";
import Picker from "./Picker";
import type { PickerValue, PickerProps, PickerOption } from "./Picker";
import "./index.scss";

export type PickerDataType = PickerValue;
export type PickerDataOptionType = PickerOption;
export interface PickerFieldProps<T extends PickerValue>
  extends PropsWithChildren<PickerProps> {
  title?: ReactNode | string;
  data: T[] | T[][];
  className?: string;
  onConfirm?: (value: T[], index: number) => void;
}

const PickerField = <T extends PickerValue>(
  props: PickerFieldProps<T>
): ReactElement => {
  const { className, children, onCancel, ...rest } = props;
  const [visible, setVisible] = useState(false);

  function handleClick(): void {
    if (rest.data.length <= 0) return;
    setVisible(true);
  }

  function handleClose(): void {
    setVisible(false);
    onCancel?.();
  }

  return (
    <div
      className={classNames("xh-picker-field", className)}
      onClick={handleClick}
    >
      {children}
      <Picker
        visible={visible}
        onCancel={handleClose}
        onClose={handleClose}
        {...rest}
      />
    </div>
  );
};

export default PickerField;
